import { Rol } from './rol';
import { Observable } from 'rxjs';

export class CategoriaPreguntasFrecuentes {
  id: number;
  nombre: string;
  nombrePt: string;
  activo: boolean;
  orden: number;
}

export abstract class CategoriaPreguntasFrecuentesData {
  abstract getList(): Observable<CategoriaPreguntasFrecuentes[]>;
  abstract create(formData: FormData): Observable<any>;
  abstract update(formData: FormData): Observable<any>;
  abstract delete(documentId: number): Observable<any>;

}

